import { useLayoutEffect, useRef, useState } from 'react'
import { BLUR_HASH_MAP } from '@constants/BlurHashItems'
import BlurHashImage from '@components/BlurHashImage'
import { imageLoadCache } from '@utils/image-load-cache'
import images from '@assets/images'
import '../GalleryPage.css'

function Video({ src, alt, onClick }) {
  const imgRef = useRef(null)
  const [loaded, setLoaded] = useState(() => imageLoadCache.has(src))

  // Catch browser-cache hits (img.complete=true) before the browser's first paint
  useLayoutEffect(() => {
    if (!loaded && imgRef.current?.complete) {
      imageLoadCache.add(src)
      setLoaded(true)
    }
  }, [src]) // intentionally omits `loaded` — only needs to run when src changes

  return (
    <div
      className={`gallery-video${loaded ? ' gallery-video--loaded' : ''}`}
      onClick={onClick}
    >
      <BlurHashImage hash={BLUR_HASH_MAP.gallery} fadeOut={loaded} />
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className="gallery-video__thumb"
        loading="lazy"
        onLoad={() => { imageLoadCache.add(src); setLoaded(true) }}
      />
      <div className="gallery-video__overlay">
        <div className="gallery-video__play-btn">
          <img src={images.iconPlay} alt="Play Video" className="gallery-video__play-icon" />
        </div>
      </div>
    </div>
  )
}

export default Video
